export const GET_ALL_PENDING_JOBS = {
    INIT: "GET_ALL_PENDING_JOBS_INIT",
    SUCCESS: "GET_ALL_PENDING_JOBS_SUCCESS",
    ERROR: "GET_ALL_PENDING_JOBS_ERROR"
}